// @flow
import LegalPage from "./LegalPage";

export type { LegalPageType } from "./LegalPage";
export default LegalPage;
